import { Alert, ButtonBase, Stack, Typography } from '@mui/material';
import CloseOutlined from '@mui/icons-material/CloseOutlined';
import { ApplicationProgressSection } from '../../dashboard/components';
import { useNavigate } from 'react-router-dom';
import { useHeaderContext } from '../../contexts/HeaderContext';
import { usePageTitle } from '@enroller/utils';
import { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

const formsProgressInfo = [
  {
    label: 'Family',
    progress: 70,
    route: 'application/family',
  },
  {
    label: 'Biography',
    progress: 70,
    route: 'application/biography',
  },
  {
    label: 'Housing',
    progress: 90,
    route: 'application/housing',
  },
  {
    label: 'Dear Family',
    progress: 0,
    route: 'application/dear-family',
  },
  {
    label: 'Photo Album',
    progress: 50,
    route: 'application/photo-album',
  },
  {
    label: 'Documents',
    progress: 40,
    route: 'application/documents',
  },
];

export const StudentDashboard = () => {
  const { user } = useAuth0();
  const { setHeaderTitle } = useHeaderContext();
  const { setPageTitle } = usePageTitle();
  const navigate = useNavigate();

  useEffect(() => {
    setHeaderTitle({ title: `Hi ${user?.name}`, subtitle: '' });
    setPageTitle(`Hi ${user?.nickname}`);
  }, [setHeaderTitle, setPageTitle, user]);

  return (
    <Stack spacing={3}>
      <Alert sx={{ alignItems: 'flex-start' }} variant="outlined" severity="info">
        <Stack direction="row">
          <Stack>
            <Typography variant="h6">Welcome to GO</Typography>
            <Typography variant="subtitle1">
              Complete your application to and begin your journey as an international student in the US. In a laoreet purus. Integer turpis quam, laoreet id
              orci nec, ultrices lacinia nunc. Aliquam erat voDonec sed erat ut magna suscipit mattis. Aliquam erat volutpat. Morbi in orci risus. Donec
              pretium.
            </Typography>
          </Stack>

          <Stack>
            <ButtonBase>
              <CloseOutlined />
            </ButtonBase>
          </Stack>
        </Stack>
      </Alert>
      <ApplicationProgressSection
        title="Application Completion"
        estimatedTime="5 minutes"
        progress={80}
        formProgressButtons={formsProgressInfo}
        completeApplicationButtonLabel={'Complete your Application'}
        onClickCompleteApplication={() => navigate('application/interview')}
      />
    </Stack>
  );
};
